import { AlertTriangle } from 'lucide-react';
import { describeMetaScopeEs } from 'utils/metaPermissionErrors';

/**
 * Inline Meta permission notice (Spanish). Use inside Meta account selector area — not global toasts.
 */
const MetaPermissionInlineNotice = ({
  message,
  missingPermissions = [],
  onReconnect,
  reconnectLabel = 'Volver a conectar Meta',
  variant = 'dark',
  className = '',
}) => {
  const isLight = variant === 'light';
  const showScopeHelper = missingPermissions.length > 0;

  return (
    <div
      role="alert"
      className={`
        rounded-xl border p-4 shadow-lg
        ${isLight
          ? 'bg-amber-50 border-amber-200 text-amber-950'
          : 'backdrop-blur-md bg-amber-500/15 border border-amber-400/40 text-amber-50'
        }
        ${className}
      `}
    >
      <div className="flex gap-3">
        <AlertTriangle
          className={`h-5 w-5 flex-shrink-0 mt-0.5 ${isLight ? 'text-amber-600' : 'text-amber-300'}`}
          aria-hidden
        />
        <div className="min-w-0 flex-1 space-y-2">
          <p className={`text-sm leading-snug ${isLight ? 'text-gray-900' : 'text-amber-50/95'}`}>
            {message}
          </p>
          {showScopeHelper && (
            <>
              <p className={`text-xs leading-relaxed ${isLight ? 'text-gray-700' : 'text-amber-100/85'}`}>
                Asegúrate de aceptar todos los permisos en la ventana de Meta.
              </p>
              <ul className={`text-xs list-disc pl-4 space-y-0.5 ${isLight ? 'text-gray-600' : 'text-amber-100/80'}`}>
                {missingPermissions.map((scope) => (
                  <li key={scope}>{describeMetaScopeEs(scope)}</li>
                ))}
              </ul>
            </>
          )}
          {typeof onReconnect === 'function' && (
            <button
              type="button"
              onClick={onReconnect}
              className={`
                mt-1 inline-flex items-center justify-center min-h-[44px] sm:min-h-[36px] px-4 py-2 rounded-lg text-sm font-semibold transition-all
                focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                ${isLight
                  ? 'bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white focus-visible:outline-blue-500'
                  : 'bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white focus-visible:outline-amber-300'
                }
              `}
            >
              {reconnectLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MetaPermissionInlineNotice;
